module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ed-modal', {
    attrs: {
      "title": (this.$store.state.ltcat.title + ' Novo GHE'),
      "modal": _vm.showFormEdit,
      "loadingSave": _vm.config.loading.save,
      "onClose": _vm.onClose,
      "onSave": (_vm.tagConfig == 'tab-cadastro' ? this.salvar : null),
      "width": "98%"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.config.loading.content),
      expression: "config.loading.content"
    }],
    attrs: {
      "slot": "modal-content"
    },
    slot: "modal-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.tagConfig),
      callback: function($$v) {
        _vm.tagConfig = $$v
      },
      expression: "tagConfig"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Config",
      "name": "tab-cadastro"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Informações do GHE\n          ")]), _vm._v(" "), _c('ed-form', {
    attrs: {
      "data": _vm.formData,
      "config": _vm.config,
      "response": _vm.response,
      "itens": _vm.formItems
    }
  }, [_c('div', {
    attrs: {
      "slot": "form-footer"
    },
    slot: "form-footer"
  }, [_c('div', {
    staticClass: "mb-2 text-left"
  }, [_c('ed-button', {
    attrs: {
      "icon": "fa fa-plus-circle",
      "type": "text",
      "value": "Inserir Nova Linha"
    },
    on: {
      "click": _vm.onRegister
    }
  }), _vm._v(" "), _c('b-table', {
    staticClass: "table-v2",
    attrs: {
      "striped": "",
      "hover": "",
      "bordered": "",
      "small": "",
      "show-empty": "",
      "sort-icon-left": "",
      "responsive": "",
      "head-variant": "light",
      "empty-text": "Nenhum item encontrado",
      "busy": _vm.config.loading.content || _vm.config.loading.copiar,
      "items": _vm.tableData,
      "fields": _vm.tableHead,
      "stacked": (this.device == 'xs')
    },
    scopedSlots: _vm._u([{
      key: "head()",
      fn: function(data) {
        return [_c('span', {
          staticStyle: {
            "font-size": "7pt"
          }
        }, [_vm._v(_vm._s(data.label.toUpperCase()))])]
      }
    }, {
      key: "table-colgroup",
      fn: function(scope) {
        return _vm._l((scope.fields), function(field) {
          return _c('col', {
            key: field.key,
            style: ({
              width: field.width
            })
          })
        })
      }
    }, {
      key: "cell()",
      fn: function(data) {
        return [(data.field && data.field.show_text) ? _c('el-input', {
          attrs: {
            "maxlength": 150,
            "disabled": data.item._data.ativo == 0,
            "type": "text"
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : (data.field && data.field.show_numeric) ? _c('el-input-number', {
          attrs: {
            "disabled": data.item._data.ativo == 0,
            "min": 0
          },
          on: {
            "change": _vm.formatData
          },
          model: {
            value: (data.item._data[data.field.key]),
            callback: function($$v) {
              _vm.$set(data.item._data, data.field.key, $$v)
            },
            expression: "data.item._data[data.field.key]"
          }
        }) : _vm._e()]
      }
    }, {
      key: "cell(buttons)",
      fn: function(data) {
        return [_c('div', {
          staticClass: "text-centers"
        }, [_c('ed-button', {
          attrs: {
            "icon": "fa fa-trash",
            "type": "danger",
            "size": "mini",
            "title": "Deletar Registro"
          },
          on: {
            "click": function($event) {
              return _vm.onDelete(data)
            }
          }
        })], 1)]
      }
    }])
  })], 1)])])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5f9bbf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/ltcat/ghe/cadastrar.vue
// module id = 1582
// module chunks = 45